import TriggerConfig from 'eflex/models/trigger-config';

export default class NodeRedTriggerConfig extends TriggerConfig {}
